import { useLocalObservable } from "mobx-react-lite";
import { getUid, isLogin } from "../services/LoginService";
import StoreAction from "./StoreAction";

const initialState = {
  login: null,
  uid: [],
  user: {},
};
const LoginStore = () => {
  const store = useLocalObservable(() => ({
    /*observables*/
    ...initialState,
    ...StoreAction(initialState),
    handleChange() {
      this.login = isLogin();
      this.uid = getUid();
    },
  }));

  return store;
};

export default LoginStore;
